import createGetFormError from './selectors/getFormError';
import plain from './structure/plain';
export default createGetFormError(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/getFormError.js
// module id = OUFX
// module chunks = 1